import { useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import LaborIssueContainer from "../../Container/MainContainer/LaborIssueContainer";
import WebToonContainer from "../../Container/MainContainer/WebtoonContainer";
import WebToonMenuGalleryContainer from "../../Container/MainContainer/WebToonMenuGalleryContainer";
import WebToonTotalContainer from "../../Container/MainContainer/WebToonTotalContainer";

function WebToonRouter({ match, location, history }: RouteComponentProps) {
  return (
    <Switch>
      <Route
        exact
        path={"/webtoon/view/:webtoon_id"}
        component={({ match, location, history }: RouteComponentProps) => {
          return <WebToonContainer match={match} history={history} />;
        }}
      />
      <Route
        exact
        path={"/webtoon/page/:webtoon_program_id"}
        component={({ match, location, history }: RouteComponentProps) => {
          return (
            <WebToonMenuGalleryContainer match={match} history={history} />
          );
        }}
      />
      <WebToonTotalContainer
        match={match}
        location={location}
        history={history}
      />
    </Switch>
  );
}
export default WebToonRouter;
